import { useCurrentUser } from '@hooks/useCurrentUser'
import { TCurrentUser } from '@types/common'
export type TFooterLink = {
    text: string
    route: string
    openInNewTab?: boolean
    include?: boolean
}

export type TFooterSection = { heading?: string; links?: TFooterLink[]; defaultExpanded?: boolean }

function getFooterLinks(currentUser: TCurrentUser): TFooterSection[] {
    return [
        {
            heading: 'About',
            links: [
                {
                    text: 'About',
                    route: `https://www.internations.org/about-internations${currentUser ? `?ref=fo_ab` : ''}`,
                },
                {
                    text: 'Team',
                    route: `https://www.internations.org/career/#team${currentUser ? `?ref=fo_te` : ''}`,
                },
                {
                    text: 'Sustainability',
                    route: `https://www.internations.org/sustainability${currentUser ? `?ref=fo_sus` : ''}`,
                },
                {
                    text: 'Press',
                    route: `https://www.internations.org/press-release${currentUser ? `?ref=fo_ps` : ''}`,
                },
                { text: 'Careers', route: `https://www.internations.org/career${currentUser ? `?ref=fo_car` : ''}` },
                {
                    text: 'Contact us',
                    route: `https://www.internations.org/about/contact?intent=general${
                        currentUser ? `&ref=fo_co` : ''
                    }`,
                },
                {
                    text: 'Advertise with us',
                    route: `https://www.internations.org/about/advertise-with-us${currentUser ? `?ref=fo_ad` : ''}`,
                },
            ],
        },

        ...(currentUser
            ? [
                  {
                      heading: 'Features',
                      links: [
                          {
                              text: 'Start',
                              route: 'https://www.internations.org/start?ref=fo_st',
                          },
                          {
                              text: 'Members',
                              route: 'https://www.internations.org/members?ref=fo_me',
                          },
                          { text: 'Forum', route: 'https://www.internations.org/forum?ref=fo_fo' },
                          { text: 'Guide', route: 'https://www.internations.org/guide?ref=fo_gu' },
                          { text: 'Groups', route: 'https://www.internations.org/groups?ref=fo_gr' },
                          {
                              text: 'Events',
                              route: 'https://www.internations.org/events/mine?ref=fo_ca',
                          },
                      ],
                  },
              ]
            : [
                  {
                      heading: 'Explore',
                      links: [
                          {
                              text: 'Communities by country',
                              route: 'https://www.internations.org/all-internations-countries',
                          },
                          {
                              text: 'Communities by city',
                              route: 'https://www.internations.org/all-internations-cities',
                          },
                          {
                              text: 'Country & City Guides',
                              route: 'https://www.internations.org/guide/all',
                          },
                          // We do not link the forum on logged-out SEO pages
                      ],
                  },
              ]),

        ...(currentUser
            ? [
                  {
                      heading: 'Essentials',
                      links: [
                          { text: 'FAQ', route: 'https://support.internations.org/hc/en-us', openInNewTab: true },

                          {
                              text: 'Request Support',
                              route: 'https://www.internations.org/support/request?ref=fo_sp&intent=support',
                          },
                          {
                              text: 'Invite Friends',
                              route: 'https://www.internations.org/invite?ref=fo_if',
                          },
                          {
                              text: 'Membership',
                              route: 'https://www.internations.org/subscription?ref=fo_mem',
                          },
                          {
                              text: 'Partner Offers',
                              route: 'https://partner.internations.org?ref=fo_po',
                          },
                          {
                              text: 'Magazine',
                              route: 'https://www.internations.org/magazine?ref=fo_em',
                          },
                          {
                              text: 'Expat Insider',
                              route: 'https://www.internations.org/expat-insider?ref=fo_exi',
                          },
                      ],
                  },
              ]
            : [
                  {
                      heading: 'Essentials',
                      links: [
                          { text: 'FAQ', route: 'https://support.internations.org/hc/en-us', openInNewTab: true },

                          {
                              text: 'Request Support',
                              route: 'https://www.internations.org/support/request',
                          },
                          {
                              text: 'Partner Offers',
                              route: 'https://partner.internations.org',
                          },
                          {
                              text: 'Magazine',
                              route: 'https://www.internations.org/magazine',
                          },
                          {
                              text: 'Expat Insider',
                              route: 'https://www.internations.org/expat-insider',
                          },
                          {
                              text: 'Cancel subscription',
                              route: 'https://www.internations.org/about/contact?intent=cancellation',
                          },
                      ],
                  },
              ]),

        ...(currentUser
            ? [
                  {
                      heading: 'Community',
                      links: [
                          {
                              text: 'Get Involved',
                              route: 'https://www.internations.org/get-involved?ref=fo_gi',
                          },
                          {
                              text: 'InterNations Ambassador',
                              route: 'https://www.internations.org/get-involved/ambassador?ref=fo_ina',
                          },
                          {
                              text: 'InterNations Consul',
                              route: 'https://www.internations.org/get-involved/consul?ref=fo_inc',
                          },
                          {
                              text: `${currentUser.localcommunityName} Community Team`,
                              route: 'https://www.internations.org/community-team?ref=fo_lct',
                          },
                          {
                              text: 'Community Guidelines',
                              route: 'https://www.internations.org/guidelines/networking?ref=fo_cg',
                          },
                          {
                              text: 'Safety Tips',
                              route: 'https://www.internations.org/community-guidelines/safety?ref=fo_st',
                          },
                          {
                              text: 'Changemakers',
                              route: 'https://www.internations.org/changemakers?ref=fo_ai',
                          },
                      ],
                  },
              ]
            : [
                  {
                      heading: 'Community',
                      links: [
                          {
                              text: 'Community Guidelines',
                              route: 'https://www.internations.org/guidelines/networking',
                          },
                          {
                              text: 'Changemakers',
                              route: 'https://www.internations.org/changemakers',
                          },
                      ],
                  },
              ]),
    ]
}

export function useFooterLinks(): TFooterSection[] {
    const { data: currentUser } = useCurrentUser()

    return getFooterLinks(currentUser)
}
